import { useTranslation } from 'react-i18next'

import { StatusBadge } from '../../../../ui/StatusBadge'
import { TypeBadge } from '../../../../ui/TypeBadge'

import type { TenantDetailsProps } from './TenantDetails.types'

function TenantDetails(props: TenantDetailsProps) {
  const { tenant, dataTestId } = props
  const { t } = useTranslation()

  if (!tenant) {
    return (
      <div className="p-6">
        <p className="text-left">{t('Tenants.Profile.Details.Empty')}</p>
      </div>
    )
  }

  return (
    <div className="p-6" data-testid={dataTestId}>
      <dl className="mt-6 space-y-2 text-sm text-left">
        <div className="flex">
          <dt className="w-48 font-semibold">
            {t('Tenants.Profile.Fields.TenantType')}:
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <TypeBadge type={tenant?.managementType} />
          </dd>
        </div>

        <div className="flex">
          <dt className="w-48 font-semibold">
            {t('Tenants.Profile.Fields.Status')}:
          </dt>
          <dd>
            <StatusBadge status={tenant?.status} />
          </dd>
        </div>

        <div className="flex">
          <dt className="w-48 font-semibold">
            {t('Tenants.Profile.Fields.CurrentLicensePackage')}:
          </dt>
          <dd className="capitalize">{tenant?.license?.package}</dd>
        </div>
      </dl>
    </div>
  )
}

export default TenantDetails
